import React from 'react';
import s from './FooterBlock.module.scss';

const FooterBlock = ({cop}) => {
    return (
        <div className={s.cover}>
            {cop && <p className={s.cop}>{cop}</p>}
        </div>
    );
}

export default FooterBlock;